v{{ version }} - {{ language$ | async | uppercase }} - {{ environment | uppercase }}
